import { z } from 'my-zod'
import { customerWaiversModel } from '../../customer-operations/customer-waiver'
import { modelsModel } from '../../fleet-operations/model'
import { vehicleUseHistoryModel } from '../../outfitter-operations/vehicle-use-history'
import { operatorsModel } from '../outfitter'

const rentalArchiveDetailsCustomerWaiver = customerWaiversModel
  .pick({
    id: true,
    productLineForRental: true,
    operatorCustomProductForRental: true,
    proposedRideDate: true,
    driverFirstName: true,
    driverLastName: true,
    driverAddressLine1: true,
    driverAddressLine2: true,
    driverAddressCity: true,
    driverAddressState: true,
    driverAddressCountry: true,
    driverPostalCode: true,
    driverDOB: true,
    driverEmail: true,
    driverPrimaryPhone: true,
    driverLicenseState: true,
    driverLicenseNumber: true,
    waiverAgreementPdfUrl: true,
    waiverQuestions: true,
    additionalParticipantFullName1: true,
    additionalParticipantFullName2: true,
    additionalParticipantFullName3: true,
    additionalParticipantFullName4: true,
    additionalParticipantFullName5: true,
    isParticipant1Minor: true,
    isParticipant2Minor: true,
    isParticipant3Minor: true,
    isParticipant4Minor: true,
    isParticipant5Minor: true,
    operatorId: true,
    rentalLengthHours: true,
    waiverFormSnapshotUrl: true,
    waiverOrigination: true,
    createdDate: true
  })
  .augment({
    operatorName: operatorsModel.shape.businessName
  })

const rentalArchiveDetailsVehicleUse = vehicleUseHistoryModel
  .pick({
    id: true,
    vin: true,
    vehicleId: true,
    operatorUnitNumber: true,
    checkOutFormSnapshotUrl: true,
    checkInFormSnapshotUrl: true,
    checkOutDateTime: true,
    dueBackDateTime: true,
    checkInDateTime: true,
    checkInDidCustomerHitAnything: true,
    checkInDidVehicleHaveMechanicalOrElectricalIssue: true,
    customerMachineRanOk: true,
    damageWaiverPlanId: true,
    modelName: true,
    checkOutFuelLevel: true,
    checkOutTreadDepth32ndInches: true,
    checkOutEngineHours: true,
    checkOutMileage: true,
    checkInFuelLevel: true,
    checkInTreadDepth32ndInches: true,
    checkInEngineHours: true,
    checkInMileage: true,
    checkOutVehicleImages: true,
    checkInVehicleImages: true,
    gearUsage: true,
    rentalLengthHours: true,
    checkOutConditionNotes: true,
    checkInConditionNotes: true
  })
  .augment({
    modelName: modelsModel.shape.modelName,
    driverName: z.string().nullish()
  })

export const rentalArchiveDetailsSystemView = z.object({
  customerWaiver: rentalArchiveDetailsCustomerWaiver,
  vehicleUseHistory: rentalArchiveDetailsVehicleUse.array()
})
export type rentalArchiveDetailsSystemView = z.infer<typeof rentalArchiveDetailsSystemView>

export const rentalArchiveSearchResultSystemView = customerWaiversModel
  .pick({
    id: true,
    productLineForRental: true,
    operatorCustomProductForRental: true,
    proposedRideDate: true,
    driverFirstName: true,
    driverLastName: true,
    driverEmail: true,
    operatorId: true,
    vehicleModel: true,
    rentalLengthHours: true,
    waiverOrigination: true,
    createdDate: true,
    additionalParticipantFullName1: true,
    additionalParticipantFullName2: true,
    additionalParticipantFullName3: true,
    additionalParticipantFullName4: true,
    additionalParticipantFullName5: true,
    isParticipant1Minor: true,
    isParticipant2Minor: true,
    isParticipant3Minor: true,
    isParticipant4Minor: true,
    isParticipant5Minor: true
  })
  .augment({
    operatorName: operatorsModel.shape.businessName
  })
export type rentalArchiveSearchResultSystemView = z.infer<typeof rentalArchiveSearchResultSystemView>
